import { render, staticRenderFns } from "./PremadeMessagesPopup.vue?vue&type=template&id=569656fe&"
import script from "./PremadeMessagesPopup.vue?vue&type=script&lang=js&"
export * from "./PremadeMessagesPopup.vue?vue&type=script&lang=js&"
import style0 from "./PremadeMessagesPopup.vue?vue&type=style&index=0&id=569656fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports